import { Separator } from '@ais-ui/ui-core';
import { MapForm } from './MapForm';
import { useLocalization } from '@ais-ui/locale-management';

export function SettingsMapPage() {
  const { messages } = useLocalization();

  return (
    <div className="space-y-6 w-full">
      <div>
        <h3 className="text-2xl font-medium">{messages.settingsMapTitle}</h3>
        <p className="text-sm text-muted-foreground">
          {messages.settingsMapSubtitle}
        </p>
      </div>
      <Separator className="w-full" />
      <MapForm />
    </div>
  );
}
